/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_Associated_GatewayInputs */



/**
* | output |
* | --- |
* | "Check status of associated gateway" |
*
* @param {Verify_Associated_GatewayInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const verify_associated_gateway = /** @type {((inputs?: Verify_Associated_GatewayInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_Associated_GatewayInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Check status of associated gateway")
	return /** @type {LocalizedString} */ ("Vérifier état de la box associée")
});